enum sensorDataType{
    GET_SENSOR_DATA_START='GET_SENSOR_DATA_START',
    GET_SENSOR_DATA_SUCCESS = 'GET_SENSOR_DATA_SUCCESS',
    GET_SENSOR_DATA_ERROR = 'GET_SENSOR_DATA_ERROR',
    GET_SENSOR_DATA_BY_ID_START='GET_SENSOR_DATA_BY_ID_START',
    GET_SENSOR_DATA_BY_ID_SUCCESS='GET_SENSOR_DATA_BY_ID_SUCCESS',
    GET_SENSOR_DATA_BY_ID_ERROR='GET_SENSOR_DATA_BY_ID_ERROR',
    RESET_GET_SENSOR_DATA_BY_ID_STATE='RESET_GET_SENSOR_DATA_BY_ID_STATE',
}

export default sensorDataType;